<template>
  <a-row>
    <a-col span="24">
      <a-spin :spinning="loading">
        <a-row>
          <a-col>
            <a-form layout="inline">
              <a-form-item label="院校">
                <a-select
                  v-model="queryParam.companyId"
                  allowClear
                  placeholder="院校"
                  style="width: 200px">
                  <a-select-option v-for="company in companyList" :key="company.id">
                    {{ company.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="学期">
                <a-select
                  v-model="queryParam.semesters"
                  mode="multiple"
                  placeholder="请选择学期"
                  style="min-width: 280px"
                  :maxTagCount="2">
                  <a-select-option v-for="item in semesterList" :key="item.semester" :value="item.semester">
                    {{ semesterLabel(item) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <CommonPermissions :p="$permissions.TEXTBOOK.STAT">
                  <a-button type="primary" @click="search">
                    查询
                  </a-button>
                </CommonPermissions>
              </a-form-item>
            </a-form>
          </a-col>
        </a-row>
        <a-table row-key="id" :columns="columns" :data-source="list" :pagination="false" style="margin-top: 16px;">
          <CommonPermissions slot="name" :p="$permissions.TEXTBOOK.STAT" slot-scope="text, record">
            <a @click="() => goSchoolStatic(record)">{{ text }}</a>
          </CommonPermissions>
          <span slot="costTime" slot-scope="text, record">{{ formatStatItem(record.costTime) }}</span>
          <span slot="usedWeekCount" slot-scope="text, record">{{ formatStatItem(record.usedWeekCount) }}</span>
          <span slot="exerciseCount" slot-scope="text, record">{{ formatStatItem(record.exerciseCount) }}</span>
          <span slot="exerciseScore" slot-scope="text, record">{{ formatStatItem(record.exerciseScore) }}</span>
        </a-table>
      </a-spin>
    </a-col>
    <StaticDetail ref="staticDetail"/>
  </a-row>
</template>
<script>
const columns = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '名称',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '兑换册数',
    dataIndex: 'redeemCount',
    key: 'redeemCount',
  },
  {
    title: '每册平均使用时长(含练习)',
    scopedSlots: { customRender: 'costTime' },
  },
  {
    title: '每册平均使用周数',
    scopedSlots: { customRender: 'usedWeekCount' },
  },
  {
    title: '每册平均练习题次',
    scopedSlots: { customRender: 'exerciseCount' },
  },
  {
    title: '每册平均练习正确率',
    scopedSlots: { customRender: 'exerciseScore' },
  },
];

import StaticDetail from './components/StaticDetail.vue'
import TextbookStatV2Api from '@/api/src/statistics/api/TextbookStatV2Api'
import DictApi from '@/api/src/basic/api/DictApi'
import CommonPermissions from '@/components/CommonPermissions'

const textbookStatV2Api = new TextbookStatV2Api()
const dictApi = new DictApi()

export default {
  name: "TextbookStatic",
  components: {
    StaticDetail,
    CommonPermissions
  },
  data() {
    return {
      queryParam: {
        companyId: undefined,
        semesters: [],
      },
      semesterList: [],
      companyList: [],
      loading: false,
      list: [],
      columns,
    };
  },
  async mounted() {
    await Promise.all([this.getCompanyList(), this.getSemesterList()])
    await this.getData()
  },
  methods: {
    semesterLabel(item) {
      if (!item) return ''
      return item.anyDistributable === false ? `${item.semester}（已截止）` : item.semester
    },
    formatStatItem(item) {
      if (!item) return '-'
      return `${item.formatValue || ''}${item.unitLabel || ''}` || '-'
    },
    async getCompanyList() {
      this.companyList = await dictApi.getCompany() || []
    },
    async getSemesterList() {
      const resp = await textbookStatV2Api.getStatV2SemesterDict()
      this.semesterList = Array.isArray(resp) ? resp : []
      if (!this.queryParam.semesters.length && this.semesterList.length) {
        this.queryParam.semesters = [this.semesterList[0].semester]
      }
    },
    async search() {
      await this.getData()
    },
    async getData() {
      if (!this.queryParam.semesters || !this.queryParam.semesters.length) {
        this.$message.warning('请选择学期')
        return
      }
      this.loading = true
      try {
        const params = {
          semesters: this.queryParam.semesters,
        }
        if (this.queryParam.companyId) {
          params.companyId = this.queryParam.companyId
        }
        this.list = await textbookStatV2Api.getStatV2GroupByTextbook(params) || []
      } catch (e) {
        console.error(e)
        this.$message.error((e && e.message) || '获取教材统计失败')
        this.list = []
      } finally {
        this.loading = false
      }
    },
    goSchoolStatic(record) {
      const query = {
        textbookId: record.id,
        textbookName: record.name,
        semesters: (this.queryParam.semesters || []).join(','),
      }
      if (this.queryParam.companyId) {
        query.companyId = this.queryParam.companyId
        const company = this.companyList.find((item) => item.id == query.companyId)
        if (company) query.companyName = company.name
      }
      this.$router.push({ name: 'TextbookSchoolStatic', query })
    },
  }
}
</script>

<style lang="less" scoped>

</style>
